import React from "react";
import { GtmManagerContext, pushDataLayer } from "../context/gtm-manager";
export var CorporateGtmProvider = function CorporateGtmProvider(props) {
    function push(val) { var _val$eventDetailsCat; var data = Object.assign({}, val, { "eventDetails.category": (_val$eventDetailsCat = val["eventDetails.category"]) !== null && _val$eventDetailsCat !== void 0 ? _val$eventDetailsCat : "" }); pushDataLayer(data); } //   const currentPageId = ;
    return /*#__PURE__*/ React.createElement(GtmManagerContext.Provider, { value: { push: push } }, props.children);
};
